import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=1cab6aa6&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cab6aa6')) {
      api.createRecord('1cab6aa6', component.options)
    } else {
      api.reload('1cab6aa6', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=1cab6aa6&", function () {
      api.rerender('1cab6aa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jMfztW0VSlyx/JS/comp/IncreaseNumber.vue"
export default component.exports